import {Box, Chip, Typography} from "@mui/material"
import React from "react"
import {AppButton, AppSecondaryButton} from "@app-core/AppButton"
import {IEligibilityQuestionAnswer} from "models/IEligibilityQuestionAnswer"
import {NAVY, TEAL, TEAL_PILL_BG} from "theme"

interface EligibilitySummaryProps {
  answers: IEligibilityQuestionAnswer[]
  onConfirmClick: () => void
  onBack: () => void
}

// Positive outcome screen. Shows the YES areas as clean category pills (no
// icons, corrected labels from the API) and routes to payment. The old
// "Congratulations!" / "Which means:" / practitioner content is removed.
export const EligibilitySummary: React.FC<EligibilitySummaryProps> = (
  props: EligibilitySummaryProps
) => {
  const {answers, onConfirmClick, onBack} = props

  return (
    <Box padding={{xs: 3, sm: 6}}>
      <Typography
        component="h1"
        fontWeight="bold"
        fontSize={{xs: "24px", sm: "28px"}}
        color={NAVY}
        marginBottom={3}
      >
        Based on your answers, you may be eligible for the Disability Tax Credit
        in the following areas:
      </Typography>

      <Box display="flex" flexWrap="wrap" gap={1.5} marginBottom={4}>
        {answers.map((a) => (
          <Chip
            key={a.question.id}
            label={a.question.title}
            sx={{
              backgroundColor: TEAL_PILL_BG,
              color: NAVY,
              border: `1px solid ${TEAL}`,
              fontSize: "16px",
              fontWeight: 600,
              height: "auto",
              paddingY: "8px",
              "& .MuiChip-label": {whiteSpace: "normal"}
            }}
          />
        ))}
      </Box>

      <Typography fontSize="18px" color={NAVY} lineHeight={1.6}>
        The next step is to complete your detailed application. This is where we
        help you build the strongest possible case for your claim.
      </Typography>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        gap={2}
        marginTop={4}
      >
        <AppSecondaryButton onClick={onBack} sx={{minWidth: "120px"}}>
          Back
        </AppSecondaryButton>
        <AppButton onClick={onConfirmClick} sx={{minWidth: "200px"}}>
          Continue to Payment
        </AppButton>
      </Box>
    </Box>
  )
}

export default EligibilitySummary
